'use client';

import ResponsiveImage from '@/components/ResponsiveImage';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import usePollingData from '@/hooks/usePollingData';
import { cn } from '@/lib/utils';
import formatPrice from '@/utils/formatPrice';

export default function DynamicTableWIthPulling({ endPoint, initialValue }) {
  const data = usePollingData(endPoint, initialValue);

  return (
    <ScrollArea>
      <div className='flex flex-col gap-4 w-full flex-1'>
        {(Array.isArray(data) ? data : initialValue).map((item, index) => (
          <div
            key={index}
            className={cn('flex gap-2 rounded-md border border-zinc-300 px-4 py-2 items-center', {
              'border-red-400 text-red-400': item.price_24h_change < 0
            })}
          >
            <div className='flex-1 min-w-fit'>
              <div className='flex gap-2 items-center'>
                <ResponsiveImage file={item.icon} className='shrink-0 hidden xs:block sm:hidden lg:block' />
                <div className='flex items-center gap-2'>
                  {item.code}
                  <span className='text-xs hidden xs:block sm:hidden lg:block'>{item.network}</span>
                </div>
              </div>
            </div>
            <div className='text-right flex-1'>{formatPrice(item.price)}</div>
            <p className='text-right flex-1'>
              {item.price_24h_change ? (item.price_24h_change > 0 ? '+' : '-') : ''}
              {Math.abs(item.price_24h_change)}%
            </p>
          </div>
        ))}
      </div>
      <ScrollBar orientation='horizontal' />
    </ScrollArea>
  );
}
